
import { useState, useEffect } from   'react';
import {  useNavigate } from 'react-router-dom';
import { Row, Col, InputGroup, Button } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { FaUsers } from 'react-icons/fa';
import SeccionPageHeader from '../Utils/SeccionPageHeader';
import CargandoSpinner from '../Utils/CargandoSpinner';
import { useAuth } from '../../Auth/AuthContext';
import apiService from '../../Auth/apiService';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Tooltip } from 'react-tooltip';


export default function CaracterizarDFI() {
    const { token } = useAuth();
    const minDate = new Date(2020, 0, 1);
    const maxDate = new Date(); // Today
    const navigate = useNavigate();
    const [Cargando, setCargando] = useState(false);
    const [intraurbanos, setIntraurbanos] = useState([]);
    const getDateFromStorage = (key, fallback) => {
        const value = localStorage.getItem(key);
        return value ? new Date(value) : fallback;
    };
    const [fechaInicio, setFechaInicio] = useState(() => getDateFromStorage('dfi_fechaInicio', new Date()));
    const [fechaFin, setFechaFin] = useState(() => getDateFromStorage('dfi_fechaFin', new Date()));
    
    useEffect(() => {
        localStorage.setItem('dfi_fechaInicio', fechaInicio.toISOString());
    }, [fechaInicio]);

    useEffect(() => {
        localStorage.setItem('dfi_fechaFin', fechaFin.toISOString());
    }, [fechaFin]);

    function MostrarFormularioDiagnostico (row)  {
        const idDx = row.iddx;
        navigate(`/dx/formulariodfi/${idDx}`);
    }
    const columns = [
        {
            name: 'Acciones',
            cell: row => (
            <div>
                <button type="button" onClick={() => MostrarFormularioDiagnostico(row)} 
                        style={{backgroundColor: 'skyblue'}} 
                        data-tooltip-id='tooltiparriba'
                        data-tooltip-content="Ver diagnostico">
                        <FaUsers/>
                </button>
                
            </div>
            ),
            ignoreRowClick: true,
            width: '5%'
        },
        { name: 'Id', selector: row => row.iddx, sortable: true },
        { name: 'Nombres', selector: row => row.nombre, sortable: true},
        { name: 'Documento', selector: row => row.id_1_2_2_n_documento, sortable: true},
        { name: 'Municipio', selector: row => row.municipio, sortable: true},
        { name: 'Barrio', selector: row => row.vict_4_4_8__hecho_Intraurbano_Barrio, sortable: true},
        { name: 'Categoría', selector: row => row.categoria, sortable: true},
        { name: 'Factor determinante', selector: row => row.factor, sortable: true},
        { name: 'Factor incidencia', selector: row => row.res_6_1_1_factores_incidencia, sortable: true},
        
    ];
    
    useEffect(() => {
       buscarDxs(); 
    }, []);
    const buscarDxs = async () => {
        setCargando(true);
        const url = '/diagnostico/consultarintraurbanosporfecha';
        const obj = {
            fechaInicio: fechaInicio ? fechaInicio.toLocaleDateString('en-CA') : null,
            fechaFin: fechaFin ? fechaFin.toLocaleDateString('en-CA') : null
        };
        try {
            const response = await apiService.post(url, obj, token);
            if (response.status === 200) {
                setIntraurbanos(response.data.intraurbanos);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    return (
        <div className="content-wrapper">
             <SeccionPageHeader
                title="Diagnostico base - Caracterizar DFI"
                idCabezaFamilia="1"
                url="/dx/diagnosticodx"
                nombreurl="Diagnostico dx"
                nombreform="Caracterizar DFI"
            />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div id="formDiagnostico" className="card">
                    
                    <div className="row">
                    <div className="col-md-12">
                        <div className="nav-tabs-custom">
                        <div className="tab-content">
                            <div className="card mb-4">
                                <div className="card-header">
                                    <h5 className="mb-0">Listado de Interurbanos</h5>
                                </div>
                                <div className="card-body">
                                    <Row className="mb-3">
                                        <Col md={3}>
                                            <InputGroup>
                                                <InputGroup.Text>Fecha inicio</InputGroup.Text>
                                                <DatePicker
                                                    selected={fechaInicio}
                                                    onChange={date => setFechaInicio(date)}
                                                    minDate={minDate}
                                                    maxDate={fechaFin || maxDate}
                                                    dateFormat="dd/MM/yyyy"
                                                    className="form-control"
                                                    placeholderText="Seleccione fecha inicio"
                                                />
                                            </InputGroup>
                                        </Col>
                                        <Col md={3}>
                                            <InputGroup>
                                                <InputGroup.Text>Fecha fin</InputGroup.Text>
                                                <DatePicker
                                                    selected={fechaFin}
                                                    onChange={date => setFechaFin(date)}
                                                    minDate={fechaInicio || minDate}
                                                    maxDate={maxDate}
                                                    dateFormat="dd/MM/yyyy"
                                                    className="form-control"
                                                    placeholderText="Seleccione fecha fin"
                                                />
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Col md={3}>
                                            <Button variant="primary" onClick={buscarDxs}>
                                                Buscar
                                            </Button>
                                        </Col>
                                    </Row>
                                    <DataTable
                                        columns={columns}
                                        data={intraurbanos}
                                        pagination
                                        highlightOnHover
                                        dense
                                        noDataComponent="No hay datos para mostrar"
                                    />
                                </div>
                            </div>
                            
                        </div>
                        </div>
                    </div>
                    </div>
                </div> 
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
        
    )
  }